import { AUTH_LOGIN, AUTH_LOGOUT } from "../constants/actionTypes";

const initialState = {
  loggedIn: false,
  selectedGroupCompany: false,
  token: null,
  expiresIn: null,
  user: null
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_LOGIN:
      return {
        ...state,
        loggedIn: true,
        token: action.token,
        expiresIn: action.expiresIn,
        user: action.user,
        selectedGroupCompany: action.groupCompanyId ? true : false
      };
    case AUTH_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default auth;
